/**
 * File: src/data/site-config.js
 * Mô tả: Cấu hình chung của website SNT Games, thông tin thương hiệu, mạng xã hội, chỉ số studio và cài đặt SEO.
 * Liên quan: src/components/header.js, src/components/footer.js, src/components/about.js
 */

export const siteConfig = {
  name: 'SNT Games',
  slogan: 'Architects of Immersive Virtual Worlds',
  description: 'SNT Games is an independent game studio in Hanoi, Vietnam, building mobile strategy and board games, including chess and Xiangqi.',
  domain: 'https://sntgames.com',
  founded: '2024',
  founder: {
    name: 'Ha Ngoc Dung',
    role: 'Founder & Lead Developer',
  },
  contact: {
    email: 'support@sntgames.com',
    address: 'Hanoi, Vietnam',
    location: 'Hanoi, Vietnam',
  },
  // Chỉ thêm URL khi chủ dự án xác nhận quyền sở hữu kênh.
  socialLinks: [
    { name: 'Facebook', url: 'https://www.facebook.com/sntgamesstudio', verified: true },
    { name: 'TikTok', url: 'https://www.tiktok.com/@sntgamesstudio', verified: true },
    { name: 'YouTube', url: 'https://www.youtube.com/@sntgamesstudio', verified: true },
  ],
  copyright: '© 2026 SNT Games Studio. All rights reserved.',
};
